import carousel1 from "../assets/images/BANNER_WEB-2.webp";
import carousel2 from "../assets/images/MADE_IN_SPAIN-ESPANA.webp";
import home1 from "../assets/imagesNotCompressed/home1.png";
// import home2 from "../assets/imagesNotCompressed/newcollect.webp";
import newProd from "../assets/images/newprod.jpg";
export const CarouselData = [
  {
    image: newProd,
    link: "/item/71a77edd-7222-4c27-9569-d364ce47b9d9",
  },
  // {
  //   image:
  //     "https://genuins.com/cdn/shop/files/BANNER_WEB_PRINCIPAL.jpg?v=1711376271&width=1600",
  // },
];
